module.exports = __webpack_public_path__ + "static/media/banner-purple-metrics-web.34366cf2.png";